import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { DokumentUploadDatenApi } from './ModelsDokumentUploadDatenApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.DokumentCheckConvertibleRequest
 * Requestmodell zur Überpüfung der Konvertierbarkeit von Dokumenten
 * Endpoints: /api/documents/checkconvertible
 */
export class DokumentCheckConvertibleRequestApi extends BaseApiModel {
	constructor(initialProperties?: Partial<DokumentCheckConvertibleRequestApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected vorgangsnummer: number;
	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	get Vorgangsnummer(): number {
		return this.vorgangsnummer;
	}

	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	set Vorgangsnummer(value: number) {
		this.vorgangsnummer = value;
	}

	protected dokumente: DokumentUploadDatenApi[];
	/**
	 * Description: Dokumente
	 * APIL Type: Collection<ADAC.Internet.Core.Models.DokumentUploadDaten>
	 */
	get Dokumente(): DokumentUploadDatenApi[] {
		return this.dokumente;
	}

	/**
	 * Description: Dokumente
	 * APIL Type: Collection<ADAC.Internet.Core.Models.DokumentUploadDaten>
	 */
	set Dokumente(value: DokumentUploadDatenApi[]) {
		this.dokumente = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): DokumentCheckConvertibleRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, DokumentCheckConvertibleRequestApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'dokumente':
					const resultdokumente = new Array<DokumentUploadDatenApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultdokumente.push(DokumentUploadDatenApi.createFromObject(v));
						});
					}
					return resultdokumente;
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Vorgangsnummer = this.vorgangsnummer;
		const dokumenteArrayReqObject: object[] = [];
		this.dokumente.forEach((element) => {
			dokumenteArrayReqObject.push(element.toRequestObject());
		});
		result.Dokumente = dokumenteArrayReqObject;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}